import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const PageTitleUpdater = () => {
  const location = useLocation()

  useEffect(() => {
    const pageTitle = document.querySelector('h1')
    if (pageTitle && pageTitle.textContent) {
      const baseTitle = 'Rêves de Barousse'
      const text = pageTitle.textContent.trim()
      if (text === baseTitle) {
        document.title = baseTitle
      } else {
        document.title = `${text} | ${baseTitle}`
      }
    }
  }, [location])

  return null
}

export default PageTitleUpdater
